import { formValidationOptions } from '../../../constants/temporaryFundConfigsV2';
import { showFormErrorMessage } from '../../../helpers/temporaryFundHelpersV2';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { Controller } from 'react-hook-form';

const TemporaryFundChequeNumberV2 = (props) => {
  const { control, errors, paymentMethod } = props;

  return (
    <div className="d-flex align-items-top py-2 flex-wrap">
      <div className="col-12 col-sm-4 pt-2">
        Check Number<span className="alert-star">*</span>
      </div>
      <div className="col-12 col-sm-8 pt-2">
        <Controller
          control={control}
          name={formValidationOptions?.chequeNumber?.name}
          rules={
            paymentMethod === 'cheque_payment' || paymentMethod === 'to_client' || paymentMethod === 'to_third_party'
              ? formValidationOptions?.chequeNumber?.rules
              : { required: false }
          }
          render={({ field }) => (
            <InputText
              className="input-shadow w-100"
              placeholder="Enter Check Number"
              name={field?.name}
              value={field?.value}
              onChange={(e) => field.onChange(e.target.value)}
              autoComplete="off"
            />
          )}
        />
        {showFormErrorMessage(formValidationOptions?.chequeNumber?.name, errors)}
      </div>
    </div>
  );
};

export default TemporaryFundChequeNumberV2;
